import {
  CLIENT_FORGOT_PASSWORD,
  CLIENT_FORGOT_PASSWORD_SUCCESS,
  CLIENT_FORGOT_PASSWORD_ERROR,
  CLIENT_FORGOT_PASSWORD_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientForgotPassword = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_FORGOT_PASSWORD:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENT_FORGOT_PASSWORD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CLIENT_FORGOT_PASSWORD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENT_FORGOT_PASSWORD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientForgotPassword;
